import React from 'react';
export function BonusSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <h2 className="text-4xl md:text-6xl font-black text-black uppercase mb-4" data-id="element-27">
            TODO LO QUE TE LLEVÁS HOY
          </h2>
          <p className="text-2xl font-bold text-red-600" data-id="element-28">
            Actuá ahora y llevate estos bonos GRATIS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-29">
          {/* Main Product */}
          <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="group block relative aspect-square bg-blue-900 rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform border-4 border-gray-200" data-id="element-30">
            <img src="https://cdn.magicpatterns.com/uploads/tmUaesdN5rA7exdC7E5KLM/TOMO_1_MEGAPACK_DE_0_A_VENTAS.png" alt="Megapack" className="w-full h-full object-cover" data-id="element-31" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-4" data-id="element-32">
              <p className="text-white font-black text-lg text-center" data-id="element-33">
                MEGAPACK PRINCIPAL
              </p>
            </div>
          </a>

          {/* Bonus 1 - Sistema Diario de Ventas */}
          <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="group block relative aspect-square rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform border-4 border-yellow-400" data-id="element-34">
            <div className="absolute top-4 right-4 z-10 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase animate-pulse" data-id="element-35">
              🎁 GRATIS HOY
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/iGsbmnLhvxdPTvcooth1VH/SISTEMA_DIARIO_DE_VENTAS.png" alt="Sistema Diario de Ventas" className="w-full h-full object-cover" data-id="element-36" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-4" data-id="element-37">
              <p className="text-yellow-400 font-bold text-sm text-center" data-id="element-38">
                Valor: $29.990
              </p>
            </div>
          </a>

          {/* Bonus 2 - 100 Ideas de Contenido */}
          <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="group block relative aspect-square rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform border-4 border-yellow-400" data-id="element-39">
            <div className="absolute top-4 right-4 z-10 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase animate-pulse" data-id="element-40">
              🎁 GRATIS HOY
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/aEtipkkxDz5p48Ki9dVWkB/100_IDEAS_DE_CONTENIDO_QUE_VENDEN.png" alt="100 Ideas de Contenido que Venden" className="w-full h-full object-cover" data-id="element-41" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-4" data-id="element-42">
              <p className="text-yellow-400 font-bold text-sm text-center" data-id="element-43">
                Valor: $19.990
              </p>
            </div>
          </a>

          {/* Bonus 3 - Guiones de Venta */}
          <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="group block relative aspect-square rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform border-4 border-yellow-400" data-id="element-44">
            <div className="absolute top-4 right-4 z-10 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase animate-pulse" data-id="element-45">
              🎁 GRATIS HOY
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/rHFm74fWMt4gzZjifk4XeT/GUIONES_DE_VENTA_QUE_CONVIERTEN.png" alt="Guiones de Venta que Convierten" className="w-full h-full object-cover" data-id="element-46" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-4" data-id="element-47">
              <p className="text-yellow-400 font-bold text-sm text-center" data-id="element-48">
                Valor: $24.990
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}